import { Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { User, UserFilters } from '../../shared/models/user';
import { Pagination } from '../../shared/models/page';
import { BaseService } from './base.service';
import { map, Observable } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable({
  providedIn: 'root',
})
export class UsersService extends BaseService<User> {
  currentUser = signal<User | null>(null);
  
  baseUrl = environment.apiUrl;
  roles: string[] = [];

  constructor(
    protected override http: HttpClient,
    private permissionsService: NgxPermissionsService,
  ) {
    super(http, 'user');
  }

  getUsers(userFilters: UserFilters) {
    let params = new HttpParams();

    if (userFilters.sort) {
      params = params.append('sort', userFilters.sort);
    }
    if (userFilters.name) {
      params = params.append('name', userFilters.name);
    }

    params = params.append('pageSize', userFilters.pageSize);
    params = params.append('page', userFilters.page);

    if (userFilters.active != undefined) {
      params = params.append('active', userFilters.active);
    }

    if (userFilters.roleId != undefined) {
      params = params.append('roleId', userFilters.roleId);
    }

    return this.http.get<Pagination<User>>(`${this.baseApiUrl}`, {
      params,
    });
  }

  getUserInfo() {
    return this.http
      .get<User>(this.baseUrl + '/api/user/user-info')
      .pipe(
        map((user) => {
          this.currentUser.set(user);
          this.addPermissions();
          return user;
        })
      );
  }

  addPermissions() {
    this.permissionsService.flushPermissions();
    if (this.currentUser != null && this.currentUser()?.role?.permissions != null) {
      this.permissionsService.loadPermissions(this.currentUser()!.role!.permissions.map(p => p.name) ?? []);
    }
  }

  updateProfile(name: string, email: string) {
    return this.http.put(this.baseUrl + '/api/user/profile', { name, email });
  }

  updateUser(id: number, user: User) {
    return this.http.put(`${this.baseApiUrl}/${id}`, user);
  }

  createPanelUser(user: User) {
    return this.http.post<{ emailSent: boolean }>(`${this.baseApiUrl}`, user);
  }

  updateAvatar(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('File', file);
    formData.append('FileName', file.name);

    return this.http.put(`${this.baseUrl}/api/user/update-avatar`, formData);
  }

  changeUserStatus(userId: number, active: boolean) {
    return this.http.put(`${this.baseApiUrl}/${userId}/change-status`, { userId, active });
  }
}
